import React, {useState, useEffect, useMemo } from 'react';
import authService from './api-authorization/AuthorizeService'
import axios from 'axios'
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import DeleteUser from '@mui/icons-material/Delete'
import LockUser from '@mui/icons-material/Lock'
import UnLockUser from '@mui/icons-material/LockOpen'
import MarkEmailConfirmed from '@mui/icons-material/MarkEmailRead'
import EditUser from '@mui/icons-material/ModeEdit'
import Select from '@mui/icons-material/HowToReg'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { ConfirmProvider } from "material-ui-confirm";
import { useConfirm } from "material-ui-confirm";
import { Link } from "react-router-dom";

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function SelectUser() {
    const [token, setToken] = useState();
    const [searchString, setSearchString] = useState("");
    const [selectedUser, setSelectedUser] = useState();
    const [status, setStatus] = useState();
    const [appData, setAppData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [userRole, setUserRole] = useState("");
    const confirm = useConfirm();
    const [showSupportersOnly, setShowSupportersOnly] = useState(true); 

    const handleDelete = (user, popupState, confirm) => {
        confirm({ description: `This will permanently delete ${user.name}.` })
            .then(() => console.log('Deleted ${item}'))
            .catch(() => console.log("Deletion cancelled."));
    };


    useEffect(async () => {
        setToken(await authService.getAccessToken());
        setAuthenticated(await authService.isAuthenticated());
        var user = await authService.getUser();
        if (user != null) {
            var role = user.role;
            setUserRole(role);
            if (role.includes("Administrators")) {
                await setIsAdmin(true);
            }
                
        }
    }, []);

    const isAdminUser = () => {
        if (isAdmin) return true;
        else return false;
    };

    const columns = 
        [
            {
                name: "id",
                label: "ID",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <Tooltip title={ isAdminUser() ? "User Name : " + rowUser.userName:""}>
                                <div > {value}</div>
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "createdOn",
                label: "Registrated",
                options: {
                    filter: false,
                    sort: true,
                    display: isAdminUser(),
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <Tooltip title={isAdminUser() ? "Last Login : " + (new Date(rowUser.lastLogIn + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', }) : ""}>
                                <div > {(new Date(value + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</div>
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "lastLogIn",
                label: "Last Login",
                options: {
                    filter: false,
                    sort: true,
                    display: false,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ textAlign: "left" }}> {(new Date(value + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })}</div>
                        );
                    }
                }
            },
            {
                name: "createdFromIP",
                label: "Creation IP",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    display: false,
                    viewColumns: true,
                }
            },
            {
                name: "lastLogInFromIP",
                label: "Last Login IP",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    display: false,
                    viewColumns: true,
                }
            },
            {
                name: "userFideId",
                label: "FIDE",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
                        );
                    }
                }
            },
            {
                name: "userUscfId",
                label: "USCF",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
                        );
                    }
                }
            },
            {
                name: "name",
                label: "Name",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        let idType = rowUser.userFideId > 0 ? "FIDE" : "USCF";
                        let id = rowUser.userFideId > 0 ? rowUser.userFideId : rowUser.userUscfId;

                        return (
                            <Tooltip title={isAdminUser() ? "Phone : " + rowUser.phoneNumber : ""}>
                                <div style={{ textAlign: "left" }}> {id != -1 ? (<Link target="_blank" to={'/players/details?idtype=' + idType + '&id=' + id} className="button">{value}</Link>) : (value)}</div>
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "membershipLevel",
                label: "Level",
                options: {
                    filter: false,
                    sort: true,
                    display: isAdminUser(),
                    sortThirdClickReset: true,
                    viewColumns: true,
                }
            },
            {
                name: "emailConfirmed",
                label: "Confirmed",
                options: {
                    filter: false,
                    sort: true,
                    display: isAdminUser(),
                    sortThirdClickReset: true,
                    viewColumns: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <Tooltip title={isAdminUser() ? "Email : " + rowUser.email : ""}>
                                <Switch checked={value} />
                            </Tooltip>
                            );
                    }
                }
            },
            {
                name: "isSupporter",
                label: "Supporter",
                options: {
                    filter: false,
                    sort: true,
                    display: isAdminUser(),
                    sortThirdClickReset: true,
                    viewColumns: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <Tooltip title={isAdminUser() ? "Supporter Exp : " + rowUser.supporterStatusExpDateUtc : ""}>
                                <Switch checked={value} />
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "email",
                label: "Email",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    display: false,
                    viewColumns: true,
                }
            },
            {
                name: "phoneNumber",
                label: "Phone",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    display: false,
                    viewColumns: true,
                }
            },
            //{
            //    name: "referralId",
            //    label: "ReferralId",
            //    options: {
            //        filter: false,
            //        sort: true,
            //        sortThirdClickReset: true,
            //        display: isAdminUser(),
            //        viewColumns: true,
            //        customBodyRender: (value, tableMeta, updateValue) => {
            //            return (
            //                <div style={{ textAlign: "left" }}> {String(value).includes('USCF') ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value.split("USCF")[1]} target='_blank' rel='noreferrer'>{value}</a>) : (String(value).includes('FIDE') ? (<a href={'https://ratings.fide.com/profile/' + value.split("FIDE")[1]} target='_blank' rel='noreferrer'>{value}</a>) : value)}</div>
            //            );
            //        }
            //    }
            //},
            {
                name: "",
                label: "Actions",
                options: {
                    filter: false,
                    filterType: 'multiselect',
                    sort: false,
                    display: true,
                    sortThirdClickReset: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <div style={{ textAlign: "left" }}>
                                {/*<Tooltip title='Select User'>*/}
                                {/*    <Select color="primary"  onClick={async (e) => { e.preventDefault(); await setSelectedUser(rowUser) }}>Select</Select>*/}
                                {/*</Tooltip>*/}
                                {/*<Tooltip title="Mark Email Confirmed">*/}
                                {/*    <MarkEmailConfirmed color={isAdminUser() && !rowUser.emailConfirmed ? "primary" : "disabled"}/>*/}
                                {/*</Tooltip>*/}
                                {/*<Tooltip title="Disable User Account">*/}
                                {/*    <LockUser color={isAdminUser() ? "primary" : "disabled"}/>*/}
                                {/*</Tooltip>*/}
                                {/*<Tooltip title="Unlock User">*/}
                                {/*    <UnLockUser color={isAdminUser() ? "primary" : "disabled"}  />*/}
                                {/*</Tooltip>*/}
                                {/*<Tooltip title="Edit User">*/}
                                {/*    <EditUser color={isAdminUser() ? "primary" : "disabled"}  />*/}
                                {/*</Tooltip>*/}
                                {/*<Tooltip title="Delete User">*/}
                                {/*    <DeleteUser color={isAdminUser() ? "primary" : "disabled"} />*/}
                                {/*</Tooltip>*/}
                                {isAdmin &&
                                    <PopupState variant="popover" popupId="demo-popup-menu">
                                        {(popupState) => (
                                            <React.Fragment>
                                                <Button variant="contained" {...bindTrigger(popupState)}>
                                                    Actions
                                                </Button>
                                            <Menu {...bindMenu(popupState)}>
                                                {!rowUser.emailConfirmed &&
                                                    <MenuItem onClick={async () => { await confirmEmail(rowUser, popupState); }}>Confirm Email</MenuItem>
                                                    }
                                                    {!rowUser.isSupporter &&
                                                        <MenuItem onClick={async () => { await addOneYearSupporterMembership(rowUser, popupState); }}>Add 1 Year Supporter Membership</MenuItem>
                                                    }
                                                    {/*rowUser.isSupporter &&*/
                                                        <MenuItem onClick={async () => { await cancelSupporterMembership(rowUser, popupState); }}>Cancel Supporter Membership</MenuItem>
                                                    }
                                                    <MenuItem onClick={popupState.close}>Lock Account</MenuItem>
                                                    <MenuItem onClick={popupState.close}>Unlock Account</MenuItem>
                                                    <MenuItem onClick={popupState.close}>Set Password</MenuItem>
                                                    <MenuItem onClick={popupState.close}>Edit</MenuItem>
                                                <MenuItem onClick={async () =>
                                                {
                                                    await deleteUser(rowUser, popupState) //, confirm)
                                                    //handleDelete(rowUser, popupState);
                                                    //confirm({ description: `Warning : This will permanently delete user ${rowUser.userName}.` })
                                                    //    .then(() =>  deleteUser(rowUser, popupState))
                                                    //    .catch(() => console.log("Deletion cancelled."));
                                                }
                                                }>Delete</MenuItem>
                                                </Menu>
                                            </React.Fragment>
                                        )}
                                    </PopupState>
                                }
                                {!isAdmin &&
                                    <div>
                                        <Button variant="contained" onClick={ async()=> await setSelectedUser(rowUser)}>
                                            Select
                                        </Button>
                                    </div>
                                }
                            </div>
                        );
                    }


                }
            },
        ];

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'simple',
        expandableRows: isAdminUser(),
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        //isRowExpandable: (dataIndex, expandedRows) => {
        //    // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
        //    if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        //        return false;
        //    return true;
        //},
        isRowExpandable: (dataIndex, expandedRows) => {
            if (isAdmin)
                return true;
            return false;
        },
        //https://openbase.com/js/mui-datatables
        //onRowClick: async (rowData, rowMeta) => {
        //    //let originalIndex = rowMeta.currentTableData[tableMeta.rowIndex].index;
        //    let rowUser = appData[rowMeta.dataIndex];
        //    await setSelectedUser(rowUser)
        //},
        rowsExpanded: [],
        renderExpandableRow: (rowData, rowMeta) => {
            const detail = appData[rowMeta.dataIndex];
            const colSpan = rowData.length + 1;
            console.log(detail);
            return (
                <div><pre>{JSON.stringify(detail, null, 2)}</pre></div>
            );
        },
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
            
    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    // Soft hide the button.
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    const getAppData = async (e, playerName) => {
        e.preventDefault();
        setToken(await authService.getAccessToken());
        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }
        axios.get('/api/NACHUsers/SearchUser?showSupportersOnly='+showSupportersOnly+'&searchString=' + playerName, headers).then((response) => {
            setAppData(response.data);
            setStatus("");
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };

    /*const deleteUser = async (nachUser, popupState, confirm) => {*/
    const deleteUser = async (nachUser, popupState) => {
        popupState.close();

        confirm({ description: `This will permanently delete user account for ${nachUser.name}.`, confirmationText:'Delete' })
            .then(async () => {
                const myToken = await authService.getAccessToken();
                const requestOptions = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + myToken,
                    },
                    body: JSON.stringify(nachUser)
                };
                const res = await fetch('/api/NACHUsers/' + nachUser.id, requestOptions);
                if (res.ok) {
                    let updatedAppData = appData.filter(u => u.id !== nachUser.id);
                    setAppData(updatedAppData);
                }
            }
            )
            .catch(() => console.log("Deletion cancelled."));
    }

    const confirmEmail = async (nachUser, popupState) => {
        popupState.close();
        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify(nachUser)
        };
        const res = await fetch('/api/NACHUsers/ConfirmEmail/' + nachUser.id, requestOptions);
        if (res.ok) {
            setAppData(prevState => {
                const newState = prevState.map(obj => {
                    if (obj.id === nachUser.id) {
                        return { ...obj, emailConfirmed: 'true' };
                    }
                    return obj;
                });
                return newState;
            });
        }
    }
    
    const addOneYearSupporterMembership = async (nachUser, popupState) => {
        popupState.close();
        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify(nachUser)
        };
        const res = await fetch('/api/NACHUsers/AddOneYearSupporterMembership/' + nachUser.id, requestOptions);
        if (res.ok) {
            setAppData(prevState => {
                const newState = prevState.map(obj => {
                    if (obj.id === nachUser.id) {
                        return { ...obj, isSupporter: 'true' };
                    }
                    return obj;
                });
                return newState;
            });
        }
    }

    const cancelSupporterMembership = async (nachUser, popupState) => {
        popupState.close();
        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify(nachUser)
        };
        const res = await fetch('/api/NACHUsers/cancelSupporterMembership/' + nachUser.id, requestOptions);
        if (res.ok) {
            setAppData(prevState => {
                const newState = prevState.map(obj => {
                    if (obj.id === nachUser.id) {
                        return { ...obj, isSupporter: 'false' };
                    }
                    return obj;
                });
                return newState;
            });
        }
    }


    return (
        <Box sx={{ pt: 2, pb: 2}}>
            <Grid container direction="row" rowSpacing={1} columnSpacing={1} align-items="flex-end">
                <Grid item xs={12} lg={isAdmin? 5:12} >
                    <TextField
                        size="small"
                        fullWidth
                        id="outlined-number"
                        label={"Enter player's ID or Name (e.g. 1503014 | Magnus | Pragg | Carlsen, M | Mag Car)"}
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={searchString}
                        onChange={(e) => setSearchString(e.target.value)}
                    />
                    {/*<Checkbox disabled={!authenticated} onChange={e => { setExcludeBlitzGames(e.target.checked); }} />*/}
                    {/*<Checkbox*/}
                    {/*    checked={checked}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    inputProps={{ 'aria-label': 'controlled' }}*/}
                    {/*/>*/}
                </Grid>
                {isAdmin &&
                    <Grid item xs={12} lg={2} >
                        <FormGroup>
                            <FormControlLabel control={<Checkbox defaultChecked checked={showSupportersOnly} onChange={e => { setShowSupportersOnly(e.target.checked); }} />} label="Supporters Only" />
                        </FormGroup>
                    </Grid>
                }
                <Grid item xs={12} lg={5}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton
                            fullWidth
                            onClick={async (e) => {
                                if (searchString !== null && searchString.trim() !== '' && searchString.trim().length >= 3 && !searchString.startsWith("-1")) {
                                    await setLoading(true); await getAppData(e, searchString);
                                } else if (isAdmin) { //admin can serach by blank or shorter string (e.g. #2 - users created in the last 2 days), which will pull all users
                                    await setLoading(true); await getAppData(e, searchString);
                                }
                            }}
                            loading={loading}
                            loadingIndicator="Loading..."
                            variant="contained">
                            Search NACH Users
                        </LoadingButton>
                        {/*<Button variant="outlined" onClick={async (e) => { e.preventDefault(); await await setAppData([]); await setSelectedUser(); await setSearchString("") }}>{"Clear"}</Button>*/}
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <div>
                                <label style={{ color: 'red' }}>{status}</label>
                    </div>
                </Grid>
                {selectedUser &&
                    <Grid item xs={12}>
                        <span>{JSON.stringify(selectedUser, null, 2)}</span>
                    </Grid>
                }
                {appData.length > 0 && 
                    <Grid item xs={12}>
                        <CacheProvider value={muiCache}>
                            <ThemeProvider theme={theme}>
                                    <MUIDataTable
                                    title={<div>
                                        <Button variant="contained" color="secondary" onClick={async (e) => { e.preventDefault(); await setAppData([]); await setSelectedUser(); await setSearchString("") }}>{"Clear Results (" + appData.length + ")"}</Button>
                                            </div>}
                                        data={appData}
                                        columns={columns}
                                        options={options}
                                        components={components}
                                    />
                            </ThemeProvider>
                        </CacheProvider>
                    </Grid>
                }
            </Grid>
        </Box>
    )
}
